import $ from "jquery"
import logo from "../../assets/images/logo.png"
import close_img from "../../assets/images/close_btn.svg"
import React from "react"

const InfoComponent = () => {

    return(
    
        <div className="popup_div4 modal_description_div p-5">
            <div className="return_popup text-center">
            <img src={logo} className="pop_logo" alt="" />
                <ul className="text-left my-5">
                    <li>
                        <span className="info_text home">Return to Welcome Area</span>
                    </li>
                    <li>
                        <span className="info_text sound">Background Sounds On/Off</span>
                    </li>
                    <li>
                        <span className="info_text fav">Mark your favorites to receive access to literature via email</span>
                    </li>
                </ul>
                <p>For questions, feedback, and technical issues please<br /> contact us at: <a href="">thermatru.com/ve-helpdesk</a></p>
            </div>
        </div>
                    
    )

}



export default InfoComponent